import { useContext } from 'react';
import AuthContext from '../contexts/AmplifyAuthContext';
const useAuth = () => useContext(AuthContext);
export default useAuth;
